export const baseUrl = {
    url: process.env.REACT_APP_API_URL,
    map_api_key: process.env.REACT_APP_MAP_API_KEY,
    map_id: process.env.REACT_APP_MAP_ID,
}

